import { render } from "./ListaDisponiblesView.vue?vue&type=template&id=56f236db"
import script from "./ListaDisponiblesView.vue?vue&type=script&lang=js"
export * from "./ListaDisponiblesView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__